import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useDirectCustomerApi() {
const { config, apiFetch } = useContext(GlobalContext);
const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000";

// ✅ Helper to include token in headers
function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    "X-token": token || "",
  };
}

// ✅ Get all direct customers with optional search
 async function getAllDirectCustomers({ limit = 5, offset = 0, search = "", ...filters } = {}) {
  const bodyData = {
    limit,
    ...(search ? { search } : {}),
    ...filters, // include other filter fields if provided
  };

  // Only include search if it's non-empty
  if (search && search.trim() !== "") {
    bodyData.search = search.trim();
  }

  const response = await apiFetch(`${BASE_URL}/get_all_direct_customers`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(bodyData),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch direct customers");
  return data;
}

// ✅ Encrypt password
async function getEncryptedPassword(password) {
  const response = await apiFetch(`${BASE_URL}/encrypt_password`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ password }),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to encrypt password");
  return data.data; // encrypted password string
}


// ✅ Create a new direct customer
 async function createDirectCustomer(userData) {
  const encryptedPassword = await getEncryptedPassword(userData.password);
  const payload = { ...userData, password: encryptedPassword };
  const response = await apiFetch(`${BASE_URL}/create_direct_customer`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to create direct customer");
  return data;
}

// ✅ Update an existing direct customer
 async function updateDirectCustomer(customerId, updateData) {
  let payload = { ...updateData };
  if (updateData.password && updateData.password.trim() !== "") {
    const encryptedPassword = await getEncryptedPassword(updateData.password);
    payload.password = encryptedPassword;
  } else {
    delete payload.password;
  }


  const response = await apiFetch(`${BASE_URL}/update_direct_customer/${customerId}`, {
    method: "POST", // backend expects POST
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to update direct customer");
  return data;
}

// ✅ Get a direct customer by ID
 async function getDirectCustomerById(customerId) {
  const response = await apiFetch(`${BASE_URL}/direct_customer/${customerId}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch direct customer");
  return data;
}

// ✅ Delete a direct customer by ID
 async function deleteDirectCustomer(customerId) {
  const response = await apiFetch(`${BASE_URL}/delete_direct_customer/${customerId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to delete direct customer");
  return data;
}
 // ✅ RETURN ALL FUNCTIONS
  return {
    getAllDirectCustomers,
    createDirectCustomer,
    updateDirectCustomer,
    getDirectCustomerById,
    deleteDirectCustomer
  };

}
